import React from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import './Layout.css';

const Layout = ({ user, onLogout, children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authService.logout();
    onLogout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="header-content">
          <div className="header-left">
            <img 
              src="/images/obstnatur-logo.svg" 
              alt="ObstNatur Logo" 
              className="header-logo"
              onClick={() => navigate('/')}
            />
            <h1 onClick={() => navigate('/')}>Mosterei-Management</h1>
          </div>
          <div className="user-info">
            <span>Willkommen, {user.name}</span>
            <button onClick={handleLogout} className="logout-button">
              Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
};

export default Layout;